import { useEffect, useContext } from 'react';
import { DashboardContext } from '@/modules/dashboards/contexts/DashboardContextProvider';

export function useTimerEndListener(onLoopEnded: () => void, setIsLoading?: (loading: boolean) => void) {
  const dashboardContext = useContext(DashboardContext);
  const refreshKey = dashboardContext?.refreshKey ?? 0;

  useEffect(() => {
    if (refreshKey > 0) {
      if (setIsLoading) {
        setIsLoading(true);
      }
      onLoopEnded();
    }
  }, [refreshKey]);
}
